import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";
// eslint-disable-next-line @nx/enforce-module-boundaries
import { EditPlaylistContainer as EditPlaylist } from "@kaltura/mediaspace-shared-edit-playlist";

export const Component = EditPlaylist;

export const render = getDsLayoutComponentRenderer(EditPlaylist);
